// SmallDetailBox.js
import React, { useEffect, useState } from 'react';
import './DetailBox.css'; // You can define shared styles here

const SmallDetailBox = ({ label, value ='' }) => {
  const [Values, setValue] = useState(value);

  useEffect(() =>{
        setValue(value)
    },[value])

  return (
    <div className='small-detail-box'>
      <label className='detail-box-label fts-12 lt-gray'>{label}</label>
      <input type="text" className='small-detail-input fts-15 ftw-4' value={Values} readOnly />
    </div>
  );
};

export default SmallDetailBox;
